export interface BabelPropertyDescriptor<TTarget, TPropValue> {
    configurable: boolean;
    enumerable: boolean;
    value?: TPropValue;
    writable: boolean;
    initializer?: (this: TTarget) => TPropValue;
}

export type BabelPropertyDecorator<TTarget, TPropValue> = (
    target: TTarget,
    propertyName: string,
    descriptor: BabelPropertyDescriptor<TTarget, TPropValue>
) => BabelPropertyDescriptor<TTarget, TPropValue>;

export type BabelPropertyOrMethodDecorator<TTarget, TPropValue> = (
    target: TTarget,
    propertyName: string,
    descriptor: BabelPropertyDescriptor<TTarget, TPropValue>
) => BabelPropertyDescriptor<TTarget, TPropValue>;

export function createPropertyDecorator<TTarget, TPropValue>(
    decorator: BabelPropertyDecorator<TTarget, TPropValue>
): PropertyDecorator {
    // @ts-ignore Ибо TS-декораторы не совместимы с Babel-кими
    // https://github.com/babel/babel/issues/8864
    return decorator;
}

export function createPropertyOrMethodDecorator<TTarget, TPropValue>(
    decorator: BabelPropertyOrMethodDecorator<TTarget, TPropValue>
): PropertyDecorator & MethodDecorator {
    // @ts-ignore Ибо TS-декораторы не совместимы с Babel-кими
    // https://github.com/babel/babel/issues/8864
    return decorator;
}
